import { createSlice } from "@reduxjs/toolkit";
import { Dispatch } from "react";
import { Microservices } from "../../app/AllowedMicroservices";
import { RootState } from "../../app/store";
import apiActionCreator, { HttpMethods } from "../../services/apiActionCreator";
import { FetchStatus } from "../common/enums";

// Mirrors POST /progress-audit/progress/:progressId/lessons/:lessonId/create-and-complete
// (service-learning, SuperAdmin only) - the manual correction for a lesson
// that has no subdocument in Progress at all (never opened, or the creating
// write got lost), so there is nothing for the regular Fix to update
// (SYSTEM.debt.md ítem 29/§15.29).
interface ProgressAuditCreateLessonState {
  status: FetchStatus;
}

const initialState: ProgressAuditCreateLessonState = {
  status: FetchStatus.Idle,
};

export const progressAuditCreateLessonSlice = createSlice({
  name: "progressAuditCreateLesson",
  initialState,
  reducers: {
    fixing: (state) => {
      state.status = FetchStatus.Fetching;
    },
    fixed: (state) => {
      state.status = FetchStatus.Fetched;
    },
    error: (state) => {
      state.status = FetchStatus.Error;
    },
  },
});

export const { fixing, fixed, error } = progressAuditCreateLessonSlice.actions;

export const createAndCompleteProgressAuditLesson = (
  progressId: string,
  lessonId: string,
  onSuccess: () => void = () => {},
  onError: () => void = () => {}
) => (dispatch: Dispatch<object>) => {
  return dispatch(
    apiActionCreator({
      endpoint: `/progress-audit/progress/${progressId}/lessons/${lessonId}/create-and-complete`,
      types: {
        requestType: fixing,
        successTypes: [
          {
            actionOrCreator: fixed,
            selector: () => {
              onSuccess();
            },
          },
        ],
        errorTypes: [
          {
            actionOrCreator: error,
            selector: () => {
              onError();
            },
          },
        ],
      },
      method: HttpMethods.POST,
      microservice: Microservices.LEARNING_SERVICE,
      authenticated: true,
    })
  );
};

export const selectIsCreatingProgressAuditLesson = (state: RootState) =>
  state.progressAuditCreateLesson.status === FetchStatus.Fetching;

export default progressAuditCreateLessonSlice.reducer;
